import analytics from 'scenes/common/analytics';
import { RetrieveFunnelState } from 'scenes/retrieve/flows/types';
import {
  marshalViewLoadedEvent,
  marshalRetrieveQuoteStartEvent,
  marshalRetrieveQuoteCompleteEvent,
  marshalCallUsEvent,
} from './marshaller/marshaller';

const retrieveAnalytics = () => ({
  viewLoaded: (funnelState: RetrieveFunnelState, cid: string, qid: string) => {
    analytics().pushEvent(marshalViewLoadedEvent(funnelState, cid, qid));
  },
  retrieveQuoteStart: (
    funnelState: RetrieveFunnelState,
    quoteNumber: string
  ) => {
    analytics().pushEvent(
      marshalRetrieveQuoteStartEvent(funnelState, quoteNumber)
    );
  },
  retrieveQuoteComplete: (funnelState: RetrieveFunnelState) => {
    analytics().pushEvent(marshalRetrieveQuoteCompleteEvent(funnelState));
  },
  callUs: (funnelState: RetrieveFunnelState) => {
    analytics().pushEvent(marshalCallUsEvent(funnelState));
  },
});

export default retrieveAnalytics;
